/* eslint-disable no-case-declarations */
import React from 'react';
import { Grid, Chip } from '@mui/material';
import { isArray, isEmpty, isEqual } from 'lodash';
import dayjs from 'dayjs';
import TableFilterListItem from './table-filter-list-item';
import { advanceFilterLabels } from '../../lib/utils';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'nowrap',
    margin: '0 auto',
    width: '100%',
    minWidth: '95%',
    overflowX: 'auto',
  },
  chip: {
    margin: '8px 8px 0px 0px',
  },
};

function TableFilterList({
  filterList,
  filterUpdate,
  advancedFilters,
  defaultFilters,
  pickupZones,
  childMarkets,
  wranglers = [],
  ItemComponent = TableFilterListItem,
}) {
  const removeFilter = (filter) => {
    const updatedFilters = {
      ...advancedFilters,
      [filter]: defaultFilters[filter],
    };
    filterUpdate(updatedFilters);
  };

  const getFilterLabel = (filter, value = undefined) => {
    if (value === undefined || (isArray(value) && isEmpty(value))) return;
    switch (filter) {
      case 'pickupFieldsFilter':
        return value
          ? advanceFilterLabels[filter][value]
          : advanceFilterLabels[filter].all_vehicles;
      case 'minBatteryFilter':
        return `${advanceFilterLabels.minBatteryFilter}: ${value}%`;
      case 'maxBatteryFilter':
        return `${advanceFilterLabels.maxBatteryFilter}: ${value}%`;
      case 'pickupZonesFilter':
        const selectedZones = pickupZones.filter((zone) => value.includes(zone.value));
        const zoneNames = selectedZones.map((zone) => zone.label);
        return `${advanceFilterLabels.pickupZonesFilter}: ${zoneNames ?? zoneNames}`;
      case 'fleetFilter':
        const selectedMarkets = childMarkets.filter((market) => value.includes(market.value));
        const marketsNames = selectedMarkets.map((market) => market.label);
        return `${advanceFilterLabels.fleetFilter}: ${marketsNames ?? marketsNames}`;
      case 'taskAssigneesFilter':
        const selectedWranglers = wranglers.filter((wrangler) => value.includes(wrangler._id));
        const wranglerNames = selectedWranglers.map((wrangler) => `${wrangler.firstName} ${wrangler.lastName}`);
        if (value.includes('Unassigned')) {
          wranglerNames.unshift('Unassigned');
        }
        if (value.includes('Anyone')) {
          wranglerNames.unshift('Anyone');
        }
        return `${advanceFilterLabels.taskAssigneesFilter}: ${wranglerNames ?? wranglerNames}`;
      case 'maintenanceFilter':
        // eslint-disable-next-line no-nested-ternary
        return value === 'Yes'
          ? `${advanceFilterLabels.maintenanceFilter}: On`
          : value === 'No'
            ? `${advanceFilterLabels.maintenanceFilter}: Off`
            : `${advanceFilterLabels.maintenanceFilter}: ${value}`;
      default:
        return value instanceof Date
          ? `${advanceFilterLabels[filter]}: ${dayjs(value).format('MM/DD/YYYY')}`
          : `${advanceFilterLabels[filter]}: ${value}`;
    }
  };

  const filterChip = (index, name, value) => (
    <ItemComponent
      key={index}
      label={getFilterLabel(name, value)}
      value={value}
      onDelete={() => removeFilter(name)}
      className={styles.chip}
    />
  );

  const getFilterList = (filterList) => (
    <Grid sx={styles.root}>
      {filterList && filterList.map(
        (filterObj, index) => {
          const name = filterObj[0];
          const value = filterObj[1];
          if (!value || advancedFilters[name] === defaultFilters[name]
            || (isArray(value) && isEmpty(value))) {
            return;
          }
          return filterChip(index, name, value);
        },
      )}
      {!isEmpty(filterList) && !isEmpty(advancedFilters)
        && !isEqual(defaultFilters, advancedFilters) && (
        <Chip label="Clear All" onDelete={() => filterUpdate(defaultFilters)} sx={{ marginTop: 1 }} />
      )}
    </Grid>
  );

  return (
    <>
      {getFilterList(filterList)}
    </>
  );
}

export default TableFilterList;
